import { render, staticRenderFns } from "./BelgeTuruCreateOrUpdate.vue?vue&type=template&id=30b77cc4&"
import script from "./BelgeTuruCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./BelgeTuruCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports